/**
 * LinkedText component module.
 * @module shared/components/LinkedText
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import Popover from './Popover';
import {getBlackWhiteWithOpacity} from '../utils/colors';

const _LinkedText = styled.a`
  & {
    ${(props) => props.fontFamily && `font-family: ${props.fontFamily}` || ''};
    ${(props) => props.fontSize && `font-size: ${props.fontSize}` || ''};
    color: ${props => (!props.colorize ? getBlackWhiteWithOpacity(0.9) : props.theme.primaryColor)};
    cursor: pointer;
    ${(props) => props.verticalAlign && 'display: inline-flex;flex-direction: row;align-items: center;margin-top: 4px;' || ''};
  }
`;

/**
 * Linked Text component
 * @name LinkedText
 */
const LinkedText = (props) => {
  const target = props.href ? '_blank' : '';
  const {
    action,
    description,
    href = '#!',
    fontFamily,
    fontSize,
    children,
    colorize = true,
    verticalAlign,
  } = props;

  const attributes = {
    href,
    onClick: action ? event => {
      event.preventDefault();
      action();
    } : undefined,
    fontFamily,
    fontSize,
    target,
    colorize,
    verticalAlign,
  };

  return <Popover content={description}>
    <_LinkedText {...attributes}>{children}</_LinkedText>
  </Popover>;
};

export default LinkedText;

LinkedText.propTypes = {
  /**
   * The action to perform when the linked text is clicked
   */
  action: PropTypes.func,
  /**
   * The description for the linked text, displays in popover
   */
  description: PropTypes.string,
  /**
   * The link to open onClick (link will be opened in a new tab)
   */
  href: PropTypes.string,
  /**
   * Font Family, if not passed inherits
   */
  fontFamily: PropTypes.string,
  /**
   * Font Size, if not passed inherits
   */
  fontSize: PropTypes.string,
  /**
   * Text to display
   */
  children: PropTypes.node.isRequired,
  /**
   * (Link Color) If true (defaults to true) then uses primary color of theme otherwise black/white
   */
  colorize: PropTypes.bool,
  /**
   * Vertical align content by center
   */
  verticalAlign: PropTypes.bool,
};
